/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseDirectoryParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('directory')],
    ['id', codecString],
    ['name', codecString],
]);
export class BaseDirectory extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseDirectoryParser.decode(input).map(res => new BaseDirectory(res));
    }
    static unsafeDecode(input) {
        return BaseDirectory.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseDirectoryParser.encode(data);
    }
    static schema() {
        return BaseDirectoryParser.schema();
    }
}
